export default "__VITE_ASSET__DL1AV7tQ__"